import { MenuRoute, MenuTemplate } from './menu-route.model';
import { PROJECT_MENU_ROUTES, PROJECT_MENU_TEMPLATE } from '../../components/project/project.menu';
import { WORK_ORDER_MENU_ROUTES, WORK_ORDER_MENU_TEMPLATE } from '../../components/work-order/work-order.menu';
import { CRM_MENU_ROUTES } from '../../components/crm/crm.menu';
import { CHECKLIST_MENU_ROUTES } from '../../components/checklist/checklist.menu';
import { TIME_MENU_ROUTES } from '../../components/time/time.menu';
import { TIME_CHECK_MENU_ROUTES } from '../../components/time-check/time-check.menu';
import { REPORTS_MENU_ROUTES } from '../../components/reports/reports.menu';
import { STOCK_MENU_ROUTES } from '../../components/stock/stock.menu';
import { HANDBOOK_MENU_ROUTES } from '../../components/handbook/handbook.menu';
import { BANK_RECONCILIATION_MENU_ROUTES } from '../../components/bank-reconciliation/bank-reconciliation.menu';
import { FIXED_ASSET_MENU_ROUTES } from '../../components/fixed-asset/fixed-asset/fixed-asset.menu';
import { FIXED_ASSET_DASHBOARD_MENU_ROUTES } from '../../components/fixed-asset/dashboard/dashboard.menu';
import { FIXED_ASSET_CONTROL_PANEL_MENU_ROUTES } from '../../components/fixed-asset/control-panel/control-panel.menu';
import { FIXED_ASSET_VISMA_MENU_ROUTES } from '../../components/fixed-asset/visma/visma.menu';
import { SUBSCRIPTION_MENU_ROUTES } from '../../components/subscription/subscription.menu';
import { KONTI_CONNECT_MENU_ROUTES } from '../../components/konti-connect/konti-connect.menu';
import { MESSAGE_MENU_ROUTES } from '../../components/message/message.menu';
import { APPROVAL_MENU_ROUTES } from '../../components/approval/approval.menu';
import { NEWS_MENU_ROUTES } from '../../components/home/news/news.menu';

/**
 * Aggregated registry of all menu-eligible routes from feature modules.
 * Each feature module owns its own `*.menu.ts` manifest; this file only re-exports the union.
 */
export const ALL_MENU_ROUTES: MenuRoute[] = [
  ...PROJECT_MENU_ROUTES,
  ...WORK_ORDER_MENU_ROUTES,
  ...CRM_MENU_ROUTES,
  ...CHECKLIST_MENU_ROUTES,
  ...TIME_MENU_ROUTES,
  ...TIME_CHECK_MENU_ROUTES,
  ...REPORTS_MENU_ROUTES,
  ...STOCK_MENU_ROUTES,
  ...HANDBOOK_MENU_ROUTES,
  ...BANK_RECONCILIATION_MENU_ROUTES,
  ...FIXED_ASSET_MENU_ROUTES,
  ...FIXED_ASSET_DASHBOARD_MENU_ROUTES,
  ...FIXED_ASSET_CONTROL_PANEL_MENU_ROUTES,
  ...FIXED_ASSET_VISMA_MENU_ROUTES,
  ...SUBSCRIPTION_MENU_ROUTES,
  ...KONTI_CONNECT_MENU_ROUTES,
  ...MESSAGE_MENU_ROUTES,
  ...APPROVAL_MENU_ROUTES,
  ...NEWS_MENU_ROUTES
];

/**
 * Aggregated registry of all default menu templates from feature modules.
 * A module appears here only if it has shipped a curated default Menu1/Menu2 template
 * (Phase 6). The sync endpoint is scoped per-moduleId, so modules can opt in incrementally.
 */
export const ALL_MENU_TEMPLATES: MenuTemplate[] = [
  PROJECT_MENU_TEMPLATE,
  WORK_ORDER_MENU_TEMPLATE
];
